// extracted by mini-css-extract-plugin
export default {"bar":"AuthBar_bar__9Hrw3"};